import BlogArticleThumbCarousel from '../sections/BlogArticleThumbCarousel/index';
import BlogLatestGrid from '../sections/BlogLatestGrid/index';
import UpcomingEvents from '../sections/UpcomingEvents/index';
import BlogCarousel from '../sections/BlogCarousel/index';
import BlogLatestPosts from '../sections/BlogLatestPosts/index';
import BlogFeaturedCarousel from '../sections/BlogFeaturedCarousel/index';
import BlogLatestPods from '../sections/BlogLatestPods/index';
import BlogTagsCarousel from '../sections/BlogTagsCarousel/index';
import BlogMainInterrupterCarousel from '../sections/BlogMainInterrupterCarousel/index';

import GiftCardHero from '../sections/GiftCardHero';
import GiftCardPage from '../sections/GiftCardPage';
import HalloweenBanner from '../sections/HalloweenBanner';
import HalloweenQuadPods from '../sections/HalloweenQuadPods';
import HalloweenDualPods from '../sections/HalloweenDualPods';
import OccassionPage from '../sections/OccassionPage';
import OccassionDualPods from '../sections/OccassionDualPods';

import AmbassadorForm from '../components/AmbassadorForm';
import CarouselTimeLine from '../sections/CarouselTimeLine/index';
import PressContactForm from '../components/PressContactForm';
import StoreLocator from '../components/StoreLocator';
import ArticleTileCustom from '../components/ArticleTileCustom';

BlogArticleThumbCarousel();
BlogLatestGrid();
UpcomingEvents();
BlogCarousel();
BlogLatestPosts();
BlogFeaturedCarousel();
BlogLatestPods();
BlogTagsCarousel();
BlogMainInterrupterCarousel();

GiftCardHero();
GiftCardPage();
HalloweenBanner();
HalloweenQuadPods();
HalloweenDualPods();
OccassionPage();
OccassionDualPods();

AmbassadorForm();
CarouselTimeLine();
PressContactForm();
StoreLocator();
ArticleTileCustom();
